/**
 * Zeus Hero Effects
 * Smooth parallax scrolling + lazy animation trigger voor Zeus Hockey banners
 * Versie: 1.1
 */

(function() {
  'use strict';
  
  // Parallax configuratie
  const PARALLAX_SPEED = 0.3; // 0.1 = subtiel, 0.5 = sterk
  
  let ticking = false;
  
  /**
   * Update parallax offset voor alle zeus-hero elementen
   */
  function updateParallax() {
    const heroes = document.querySelectorAll('.zeus-hero[data-parallax="true"]');
    
    heroes.forEach(hero => {
      const rect = hero.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Alleen updaten als element in viewport is
      if (rect.bottom < 0 || rect.top > windowHeight) return;
      
      // Bereken scroll offset relatief aan element positie
      const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
      const offset = (scrollProgress - 0.5) * rect.height * PARALLAX_SPEED;
      
      // Pas CSS variable aan voor smooth animatie via CSS
      hero.style.setProperty('--scroll-offset', `${offset}px`);
    });
    
    ticking = false;
  }
  
  /**
   * Throttled scroll handler
   */
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }
  
  /**
   * Initialize animation trigger with IntersectionObserver
   */
  function initAnimationTrigger() {
    const heroes = document.querySelectorAll('.zeus-hero');
    
    if (!heroes.length) return;
    
    // Observer voor het triggeren van de animatie wanneer in beeld
    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Voeg de class toe om animatie te starten
          entry.target.classList.add('zeus-hero--in-view');
          // Stop met observeren na eerste trigger (animatie hoeft maar 1x)
          animationObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15, // Trigger wanneer 15% zichtbaar is
      rootMargin: '0px 0px -50px 0px' // Iets eerder triggeren
    });
    
    heroes.forEach(hero => {
      animationObserver.observe(hero);
    });
  }
  
  /**
   * Initialize parallax
   */
  function initParallax() {
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Still add in-view class for content visibility, but skip parallax
      document.querySelectorAll('.zeus-hero').forEach(hero => {
        hero.classList.add('zeus-hero--in-view');
      });
      return;
    }
    
    // Check for mobile (disable parallax for performance, but keep animations)
    if (window.innerWidth < 750) {
      return;
    }
    
    // Add scroll listener for parallax
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Initial update
    updateParallax();
  }
  
  /**
   * Main init
   */
  function init() {
    initAnimationTrigger();
    initParallax();
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize parallax on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Remove listener and re-init parallax only
      window.removeEventListener('scroll', onScroll);
      initParallax();
    }, 250);
  });
})();
